// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"e93774c7","691":"e93774c7","797":"e93774c7","901":"e93774c7"}[chunkId] + ".chunk.css";
};